module.exports = __webpack_public_path__ + "ath_game_web/img/Coingecko_logo.30d53b9c.png";